import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  ViewChild,
  ElementRef,
  Renderer2,
} from "@angular/core";
import { Subject } from "rxjs/Subject";
import { CanonicalService } from "../shared/canonical.service";
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { AppConfig } from '../config/app.config';
import {
  Chart,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Legend,
  Title,
  Tooltip,
  ChartConfiguration
} from 'chart.js';
import { Title as BrowserTitle, Meta } from '@angular/platform-browser';

Chart.register(BarController, BarElement, CategoryScale, LinearScale, Legend, Title, Tooltip);

@Component({
  selector: "merchant-app-application",
  templateUrl: "./merchant-app.component.html",
  styleUrls: ["./merchant-app.component.scss"],
})
export class merchantappapplicationComponent implements OnInit, AfterViewInit, OnDestroy {
  private unSubscribe = new Subject<boolean>();
  @ViewChild("mltTrnsSldShw", { static: false })
  mltTrnsSldShw: ElementRef<HTMLDivElement>;
  @ViewChild("jrnAnimCont", { static: false })
  jrnAnimCont: ElementRef<HTMLDivElement>;
  @ViewChild("crsCurAnimCont", { static: false })
  crsCurAnimCont: ElementRef<HTMLDivElement>;
  @ViewChild("jrnlAnim", { static: false })
  jrnlAnim: ElementRef<HTMLDivElement>;
  setIntrvArr = [];
  autoScrollInterval: any;
  showPlayer = false;
  Chart: any;
  activeImage = 0;
  @ViewChild("downContent", { static: false })
  downContent: ElementRef<HTMLDivElement>;
  activeColor = 1;
  images = [
    "./../assets/images/c and c image4.png",
    "./../assets/images/c and c image7.png",
  ];
  intervalId: any;
  count = 9;
  Math = Math;
  schema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "MerchantApp",
    "operatingSystem": "Web, Android, iOS",
    "applicationCategory": "Business Application",
    "url": "https://www.glbyte.com/in",
    "image": "https://www.glbyte.com/assets/images/merchantapp_og.png",
    "publisher": {
      "@type": "Organization",
      "name": "glByte Systems",
      "url": "https://www.glbyte.com"
    },
    "description": "MerchantApp is a Mini ERP and AI-powered reconciliation tool for e-commerce sellers who are selling in Multiple Ecommernce Platforms and looking for Unifed solution combing order management, reconciliation, accounting, and GST filing. It integrates marketplaces, payment gateways, and accounting tools into one unified platform.",
    "featureList": [
      "order Management",
      "eCommerce Payment Reconciliation",
      "Prevent Revenue Leakages",
      "Enhance Decision-Making",
      "Automated Accounting & Reporting",
      "GST Filing & Compliance",
      "Multi-Portal Integration (Amazon, Flipkart, Meesho, Myntra)",
      "Bank & Payment Gateway Sync"
    ],
  };

  constructor(
    private canonicalService: CanonicalService, 
    private router: Router, private el: ElementRef,
    private titleService: BrowserTitle, private meta: Meta
  ) {
    router.events.pipe(takeUntil(this.unSubscribe)).subscribe((evt: RouterEvent) => {
      this.navigationInterceptor(evt);
    });
  }

  ngOnInit() {
    // this.meta.addTags([
    //   { name: 'keywords', content: 'MerchantApp, E-commerce ERP, reconciliation software, GST automation, payment gateway integration, accounting automation' },
    //   { property: 'og:image', content: 'https://www.glbyte.com/assets/images/merchantapp_og.png' },
    //   { property: 'og:url', content: 'https://www.glbyte.com/merchantapp' },
    //   { property: 'og:type', content: 'website' },
    //   // { name: 'twitter:card', content: 'summary_large_image' },
    //   // { name: 'twitter:title', content: 'MerchantApp | AI-powered E-commerce Automation' },
    //   // { name: 'twitter:description', content: 'Reconcile, report, and automate your e-commerce operations in one app.' }
    // ]);
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(this.schema);
    document.head.appendChild(script);
      this.canonicalService.createLinkForCanonicalURL();
      this.startColorSwitching();
    }

  ngOnDestroy() {
    clearInterval(this.autoScrollInterval);
    document.querySelector("app-navbar > header").classList.remove("home");
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  navigationInterceptor(evt) {
    if (evt instanceof NavigationEnd) {
      if (evt.urlAfterRedirects === '/' + AppConfig.routes.merchantappapplication) {
        this.titleService.setTitle('MerchantApp | Unified E-commerce Automation & Reconciliation Platform');
        this.meta.updateTag({
          name: 'description',
          content: 'MerchantApp is an all-in-one platform for e-commerce sellers. Automate reconciliation, GST filing, and accounting with AI-powered insights.'
        });
        this.meta.updateTag({
          name: 'keywords',
          content: 'MerchantApp, E-commerce ERP, reconciliation software, GST automation, payment gateway integration, accounting automation.'
        });
        this.meta.updateTag({
          property: "og:title",
          content: 'MerchantApp | Unified E-commerce Platform.'
        });
        this.meta.updateTag({
          property: "og:description",
          content: 'Streamline your multi-channel sales and financials in one platform — MerchantApp automates reconciliation, accounting, and compliance.'
        });
      }
    }
  }

  startColorSwitching() {
    this.intervalId = setInterval(() => {
      this.activeColor = this.activeColor === 1 ? 2 : 1;
      this.activeImage = (this.activeImage + 1) % this.images.length;
    }, 4000);
  }

  stopColorSwitching() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
  scrollToContent() {
    this.downContent.nativeElement.scrollIntoView({ behavior: "smooth" });
  }

  ngAfterViewInit() {
    const header = document.querySelector("app-navbar > header");
    if (header) {
      header.classList.add("home");
    }

    function reveal() {
      const reveals = document.querySelectorAll(".reveal");
      for (let i = 0; i < reveals.length; i++) {
        const windowHeight = window.innerHeight;
        const revealTop = reveals[i].getBoundingClientRect().top;
        const revealPoint = windowHeight - 150;

        if (revealTop < revealPoint) {
          reveals[i].classList.add("active");
        } else {
          reveals[i].classList.remove("active");
        }
      }
    }

    window.addEventListener("scroll", reveal);

    function enterFromRight() {
      const enterFromRights = document.querySelectorAll(".enter-from-right");
      for (let i = 0; i < enterFromRights.length; i++) {
        const windowHeight = window.innerHeight;
        const enterFromRightTop =
          enterFromRights[i].getBoundingClientRect().top;
        const enterFromRightPoint = windowHeight - 150;

        if (enterFromRightTop < enterFromRightPoint) {
          enterFromRights[i].classList.add("active");
        } else {
          enterFromRights[i].classList.remove("active");
        }
      }
    }

    window.addEventListener("scroll", enterFromRight);

    function slideIn() {
      const slideIns = document.querySelectorAll(".slide-in");
      for (let i = 0; i < slideIns.length; i++) {
        const windowHeight = window.innerHeight;
        const slideInTop = slideIns[i].getBoundingClientRect().top;
        const slideInPoint = windowHeight - 150;
        if (slideInTop < slideInPoint) {
          slideIns[i].classList.add("active");
        } else {
          slideIns[i].classList.remove("active");
        }
      }
    }

    window.addEventListener("scroll", slideIn);
    slideIn();

    const container: HTMLElement = this.el.nativeElement.querySelector('.circle-container');
    const icons = container.querySelectorAll('img:not(.center-logo img)');
    const linesContainer: HTMLElement = container.querySelector('.lines');

    const step = (2 * Math.PI) / icons.length;
    icons.forEach((icon, index) => {
      const angle = step * index;
      (icon as HTMLElement).style.setProperty('--angle', `${angle}rad`);

      const line = document.createElement('div');
      line.classList.add('line');
      line.style.setProperty('--angle', `${angle}rad`);
      linesContainer.appendChild(line);
    });

    if (container) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              container.classList.add('far');
              container.classList.remove('near');
            } else {
              container.classList.add('near');
              container.classList.remove('far');
            }
          });
        },
        { threshold: 0.3 }
      );

      observer.observe(container);
    }

    const ctxe = document.getElementById('timeSavedChart1') as HTMLCanvasElement;

    const datab = {
      labels: ['Reconciliation', 'Accounting', 'GST Filing', 'Business Processing'],
      datasets: [
        {
          label: 'Manual Process (Hours/Week)',
          data: [15, 10, 8, 12],
          backgroundColor: '#d4507f',
          borderRadius: 6,
          barThickness: 20
        },
        {
          label: 'With MerchantApp (Hours/Week)',
          data: [1, 0.5, 0.5, 2],
          backgroundColor: '#4a3b73',
          borderRadius: 6,
          barThickness: 20
        }
      ]
    };

    const configt: ChartConfiguration = {
      type: 'bar',
      data: datab,
      options: {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              usePointStyle: true,
              boxWidth: 12,
              padding: 30,
              color:'black',
              font: {
                weight: 'bold'
              }
            }
          }
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Hours per Week',
              font: { size: 14 },
              color:'black',
            },
            ticks: {
              color: 'black',
              font: { weight: 'bold'}
            }
          },
          y: {
            ticks: {
              color: 'black',
              font: { weight: 'bold'}
            }
          }
        }
      }
    };

    new Chart(ctxe, configt);

    const sliders = document.querySelectorAll<HTMLElement>(".image-slider");

    sliders.forEach(slider => {
      const imgs = slider.querySelectorAll<HTMLImageElement>("img");
      let i = 0;

      if (imgs.length > 0) {
        setInterval(() => {
          imgs[i].classList.remove("active");
          i = (i + 1) % imgs.length;
          imgs[i].classList.add("active");
        }, 2000);
      }
    });
  }
}
